module.exports = (theArray = []) => {
    const results = [];
    theArray.forEach((subArray) => {
        subArray.forEach((value) => {
            results.push(value);
        });
    });
    return results;
}



// WEBPACK FOOTER //
// ./app/lib/util/concatAll.js